import { Component } from 'react';
import { Link, } from "react-router-dom";
import { Footer, SideNav, TopBar } from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
import {postData, deleteItem, updateData} from './constants.js';
const moment = require('moment');

class MassCommunicationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data            :[],
      resident_groups :[],
      isLoading       :true,
      show            :false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addMassCommunication = this.addMassCommunication.bind(this);
    this.editMassCommunication = this.editMassCommunication.bind(this);
    this.viewMassCommunication = this.viewMassCommunication.bind(this);
    this.deleteMassCommunication = this.deleteMassCommunication.bind(this);
  }

  async getMassCommunications() {
    try {
      const response = await fetch('/api/mass-communications');
      const json = await response.json();
      this.setState({ data: json.mass_communications, resident_groups: json.resident_groups });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getMassCommunications();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    var data = this.state;
    delete data.isLoading;
    delete data.show;

    if(data.id){
      updateData('/api/mass-communication/'+data.id, data)
        .then((response) => {
          console.log(response);
          this.getMassCommunications();
      });
    }else{
      postData('/api/mass-communication', data)
        .then((response) => {
          console.log(response);
          this.getMassCommunications();
      });
    }
  }

  addMassCommunication() {
    this.setState({
      id           :"",
      message      :"",
      recipient    :this.state.resident_groups.length?this.state.resident_groups[0].id:"",
      show         :true,
      show_content :"edit"
    });
  }

  editMassCommunication(e) {
    const id = parseInt(e.target.id);
    const mass_communications = this.state.data;
    const selectedMassCommunication = mass_communications.filter(e=> e.id === id)[0];
    this.setState(selectedMassCommunication);
    this.setState({ show: true, show_content:"edit" });
  }

  viewMassCommunication(e) {
    const id = parseInt(e.target.id);
    const mass_communications = this.state.data;
    const selectedMassCommunication = mass_communications.filter(e=> e.id === id)[0];
    this.setState(selectedMassCommunication);
    this.setState({ show: true, show_content:"view" });
  }

  deleteMassCommunication(e) {
    const id = parseInt(e.target.id);
    deleteItem("/api/mass-communication/"+id)
    .then((response) => {
      console.log(response);
      this.getMassCommunications();
    });
  }

  render() {
    if(!this.state.isLoading){
      const mass_communications = this.state.data;
      const mass_communication_list = mass_communications.map((mc)=>
          <tr key={mc.id} id={mc.id}>
              <td>{moment(mc.created_date).format('l')}</td>
              <td className="text-truncate" style={{maxWidth:'250px'}}>{mc.message}</td>
              <td className="text-nowrap">{mc.recipient_group}</td>
              <td className="text-nowrap">{mc.posted_by}</td>
              <td className="text-nowrap">
                <div className="row no-gutters">
                  <div className="col">
                    <i id={mc.id} className="fas fa-info-circle text-info action-icons" onClick={this.viewMassCommunication}></i>
                  </div>
                  <div className="col">
                    <i id={mc.id} className="fas fa-pencil-alt text-warning action-icons" onClick={this.editMassCommunication}></i>
                  </div>
                  <div className="col">
                    <i id={mc.id} className="fas fa-trash-alt text-danger action-icons" onClick={this.deleteMassCommunication}></i>
                  </div>
                </div>
              </td>
          </tr>
      );
      const resident_groups = this.state.resident_groups.map((group) =>
        <option key={group.id} value={group.id}>{group.group_name}</option>
      );
      return(
          <>
            {this.state.show?(
              <div className="container-fluid">
                {this.state.show_content==="edit"?(
                  <div className="card shadow mb-2">
                      <div className="card-header py-3">
                          <h4 className="m-0 font-weight-bold text-light">Add / Edit  Communication</h4>
                      </div>
                      <div className="card-body">
                          <form className="user" onSubmit={this.handleSubmit} autoComplete="off">
                            <div className="form-group">
                              <label>Recipient</label>
                              <select name="recipient" className="form-select" value={this.state.recipient} onChange={this.handleInputChange} required >
                                {resident_groups}
                              </select>
                            </div>
                              <div className="form-group">
                                  <label>Message</label>
                                  <textarea type="text" name="message" rows="8" maxLength={1000} className="form-control" value={this.state.message} onChange={this.handleInputChange} required />
                              </div>
                              <div className="form-group">
                                <input type="submit" id="mass-communication-submit" className="btn btn-bg-success" value="Submit" />
                                <button type="button" name="cancel" className="btn btn-danger mx-2" onClick={()=> this.setState({show:false})}>Cancel</button>
                              </div>
                          </form>
                      </div>
                  </div>
                ):(
                  <div className="card shadow mb-2">
                      <div className="card-header py-3">
                          <h4 className="m-0 font-weight-bold text-white">Message details</h4>
                      </div>
                      <div className="card-body event-view">
                        <div className="row mt-2">
                          <div className="col-md-2">
                            <span>Posted on</span>
                          </div>
                          <div className="col-md-4">
                            <span className="font-weight-bold text-dark"> {moment(this.state.created_date).format("LLL")} </span>
                          </div>
                          <div className="col-md-2">
                            <span>Posted By</span>
                          </div>
                          <div className="col-md-4">
                            <span className="font-weight-bold text-dark"> {this.state.posted_by} </span>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-2">
                            <span>Recipient</span>
                          </div>
                          <div className="col-md-10">
                            <span className="font-weight-bold text-dark"> {this.state.recipient_group} </span>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-6">
                            <span>Message</span>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <span className="font-weight-bold text-dark">{this.state.message}</span>
                          </div>
                        </div>
                        <button type="button" name="cancel" className="btn btn-danger mt-2" onClick={()=> this.setState({show:false})}>Cancel</button>
                      </div>
                  </div>
                )}
              </div>
            ):(
              <div className="row">
                <div className="col-md-12 col-xs-12">
                    <div className="card shadow mb-2">
                        <div className="card-header py-3">
                            <h4 className="m-0 font-weight-bold text-white"> Communications</h4>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive mass-communication-table">
                                <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                    <thead>
                                        <tr>
                                            <th>Created On</th>
                                            <th>Message </th>
                                            <th>To</th>
                                            <th>Posted by</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {mass_communication_list}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <button className="btn btn-primary" onClick={this.addMassCommunication}><i className="fas fa-plus"></i> New  Communication</button>
                </div>
              </div>
            )}
          </>
      );
    }
  }
}

function MassCommunications() {
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <MassCommunicationList />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { MassCommunications };
